import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { useVendorFlags } from "../lib/useVendorFlags";
import { STARTER_PERKS } from "../components/StarterUpgrade";

export default function ForVendors() {
  const { flags, loading } = useVendorFlags();
  const on = flags.claiming;
  return (
    <div className="min-h-screen bg-white text-black font-mono">
      <Seo
        title={on ? "For vendors — claim your listing, upgrade to Starter" : "not found"}
        description="Claim your tool's listing on TerminalValue.io for free. Upgrade to Starter for your own button, an expanded listing page and promotion to our audience."
        path="/for-vendors"
        noindex={!on || flags.admin_preview}
      />
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-10" data-testid="for-vendors-page">
        {loading ? null : !on ? (
          <p className="text-[13px]" data-testid="for-vendors-off">that page isn&apos;t available.</p>
        ) : (
          <>
            {flags.admin_preview && (
              <div className="border border-dashed border-black p-2 text-[11px] mb-6" data-testid="admin-preview-banner">
                admin preview — vendor plans are switched off for the public (Admin → + vendors).
              </div>
            )}
            <h1 className="text-xl font-bold border-b border-black pb-2">{">"}_ for vendors</h1>
            <p className="text-[13px] text-[#444] mt-3 leading-relaxed">
              Every tool on TerminalValue.io is listed for free and ranked by votes — nobody pays to be listed or to
              rank. If you build one of them, claim it and make the page yours.
            </p>

            <div className="mt-8 grid gap-6 sm:grid-cols-2">
              <section className="border border-black p-4" data-testid="plan-free">
                <h2 className="text-[15px] font-bold">Free — claim your listing</h2>
                <p className="text-[24px] font-bold mt-1">$0</p>
                <ul className="mt-2 pl-5 list-disc text-[13px] leading-relaxed">
                  <li>✓ claimed mark on your page</li>
                  <li>request corrections to your listing</li>
                  <li>&quot;Listed on TerminalValue.io&quot; embed badge</li>
                  <li>verify in 30 seconds: sign in with your work Google account, or add a meta tag</li>
                </ul>
                <p className="text-[12px] text-[#666] mt-3">Find your tool → click &quot;claim this listing&quot; at the bottom of its page.</p>
              </section>
              <section className="border-2 border-black p-4" data-testid="plan-starter">
                <h2 className="text-[15px] font-bold">Starter — make it your page</h2>
                <p className="text-[24px] font-bold mt-1">
                  $49<span className="text-[13px] font-normal">/month</span>{" "}
                  <span className="text-[13px] font-normal text-[#666]">or $495/year</span>
                </p>
                <p className="text-[11px] text-[#666]">founding price — 50% off your first year · $99/month or $990/year from year two</p>
                <ul className="mt-2 pl-5 list-disc text-[13px] leading-relaxed">
                  {STARTER_PERKS.map((p) => <li key={p}>{p}</li>)}
                </ul>
                <p className="text-[12px] text-[#666] mt-3">Claim first (free), then upgrade from your vendor dashboard. Cancel anytime.</p>
              </section>
            </div>

            <section className="mt-10 text-[13px] leading-relaxed" data-testid="for-vendors-faq">
              <h2 className="text-[15px] font-bold border-b border-[#ddd] pb-1">questions</h2>
              <p className="mt-2"><b>Does paying change our rank?</b> No. Ranking is votes only. Starter changes what your page can show, not where it sits.</p>
              <p className="mt-2"><b>Who approves page edits?</b> We do — same review as every listing, usually within two working days. Nothing goes live unreviewed.</p>
              <p className="mt-2"><b>Our tool isn&apos;t listed yet.</b> <Link to="/submit" className="tv-link">Submit it</Link> (free) and tick &quot;I work for this company&quot; — you&apos;ll be able to claim it the moment it&apos;s approved.</p>
            </section>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
